import React, { useCallback, useState } from "react";
import { Outlet } from "react-router-dom";

import DriverSidebar from "../components/layout/DriverSidebar";
import DriverTopbar from "../components/layout/DriverTopbar";
import MobileWebNotice from "../components/layout/MobileWebNotice";

import { useIsMobileViewport } from "../hooks/useIsMobileViewport";

const shellStyle: React.CSSProperties = {
  minHeight: "100vh",
  background: "var(--background)",
  color: "var(--text-primary)",
  display: "flex",
};

const contentShellStyle: React.CSSProperties = {
  flex: 1,
  minWidth: 0,
  display: "flex",
  flexDirection: "column",
};

const mainStyle: React.CSSProperties = {
  flex: 1,
  padding: "var(--page-padding)",
};

const innerContentStyle: React.CSSProperties = {
  width: "100%",
};

const DriverLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const isMobile = useIsMobileViewport();

  const handleToggleSidebar = useCallback(() => {
    setCollapsed((prev) => !prev);
  }, []);

  if (isMobile) {
    return <MobileWebNotice />;
  }

  return (
    <div style={shellStyle}>
      <DriverSidebar collapsed={collapsed} />

      <div style={contentShellStyle}>
        <DriverTopbar
          collapsed={collapsed}
          onToggleSidebar={handleToggleSidebar}
        />

        <main style={mainStyle}>
          <div style={innerContentStyle}>
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default DriverLayout;